import { render, staticRenderFns } from "./ActivityJoinChannelModal.vue?vue&type=template&id=6137b8c0&scoped=true&"
import script from "./ActivityJoinChannelModal.vue?vue&type=script&lang=js&"
export * from "./ActivityJoinChannelModal.vue?vue&type=script&lang=js&"
import style0 from "./ActivityJoinChannelModal.vue?vue&type=style&index=0&id=6137b8c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6137b8c0",
  null
  
)

export default component.exports